import React, { useContext, useEffect, useReducer, useState } from "react";


const TestComp = () => {

    const [counterState, counterDispatch] = useReducer(counterReducer, { count: 0 });
    const [toggleState, toggleDispatch] = useReducer(toggleReducer, { theme: 'light' });


    function toggleReducer(state, action) {
        switch (action.type) {
            case "light":
                return { theme: "light" };
            case "dark":
                return { theme: "dark" };
            case "toggle":
                return {}
            default:
                return state;
        }
    }


    function counterReducer(state, action) {
        switch (action.type) {
            case "increment":
                return { count: state.count + 1 };
            case "decrement":
                return { count: state.count - 1 };
            case "reset":
                return { count: 0 }
            default:
                return state;
        }
    }



    return (
        <div>
            <h1>Count : {counterState.count}</h1>
            <button onClick={() => counterDispatch({ type: 'increment' })}>+</button>
            <button onClick={() => counterDispatch({ type: 'decrement' })}>-</button>
            <button onClick={() => counterDispatch({ type: 'reset' })}>Reset</button>

            <div style={{
                background: toggleState.theme == 'light' ? 'white' : 'black',
                color: toggleState.theme == 'light' ? 'black' : 'white'
            }}>
                Symbols seen throughout the Dussehra/Vijaya Dashami celebrations include: ...
                Paper and wood effigies of Ravana. Red spots (tika) painted on people's foreheads.
                The effigies of Ravana are often burnt on the bonfires. Note: During a gazetted holiday,
                government offices
            </div>
            <button onClick={() => toggleDispatch({ type: 'toggle' })}>Toggle</button>
        </div >
    );
};

export default TestComp;



// WEBPACK FOOTER //
// ./src/scenes/Wizard/parts/test.js